import { render, staticRenderFns } from "./RoomData.vue?vue&type=template&id=346d5484&scoped=true"
import script from "./RoomData.vue?vue&type=script&lang=js"
export * from "./RoomData.vue?vue&type=script&lang=js"
import style0 from "./RoomData.vue?vue&type=style&index=0&id=346d5484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346d5484",
  null
  
)

export default component.exports